export default "__VITE_ASSET__cQ8_fub3__"